import { Directive, input, TemplateRef, ViewContainerRef, effect, inject } from '@angular/core';
import { UsersService } from '../services/users/users.service';
import { JwtUser } from '../models/user';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective {
  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private usersService = inject(UsersService);

  roles = input<string[], string | string[]>([], {
    alias: 'appHasRole',
    transform: (value: string | string[]) => Array.isArray(value) ? value : [value]
  });

  constructor() {
    effect(() => {
      const roles = this.roles();
      const user: JwtUser | null = this.usersService.getUser();
      const userGroups: string[] = user?.['cognito:groups'] || [];

      const hasRole = roles.some(role => userGroups.includes(role));
      this.viewContainer.clear();
      if (hasRole) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
